import JobCard from "../../../Molecules/JobCard";

export default function Listings({ filtered, allActive, countLabel }) {
  return (
    <section className="py-16">
      <div className="containers-min mx-auto px-4 ">
        <div className="flex justify-between items-end mb-8 flex-wrap gap-2">
          <div>
            <h2 className="text-2xl font-bold mb-1">Open Positions</h2>
            <p className="text-[var(--vm-text-gray)] mb-0">{countLabel}</p>
          </div>
        </div>

        {filtered.length === 0 ? (
          <div className="text-center py-16">
            <p className="text-[var(--vm-text-gray)] mb-0">
              {allActive.length === 0
                ? "No open positions at the moment — please check back soon."
                : "No roles match your search. Try a different keyword or clear the filters."}
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {filtered.map((job) => <JobCard job={job} key={job.id} />)}
          </div>
        )}
      </div>
    </section>
  );
}
